export default {
    getIsUnderImpersonation(state) {
        return state.isUnderImpersonation
    },
    getUserImpersonated(state) {
        return state.userImpersonated
    }
}
